module.exports = __webpack_public_path__ + "img/22.41aa651d.png";